export default __webpack_public_path__ + "static/media/purple-pattern.505cd5a77dee2428b7eb7479e323c426.svg";